import { render, staticRenderFns } from "./distributionUsers.vue?vue&type=template&id=bcc138e6&scoped=true&"
import script from "./distributionUsers.vue?vue&type=script&lang=js&"
export * from "./distributionUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcc138e6",
  null
  
)

export default component.exports